'use strict';

var React = require('react');

var SvgReportFilledMinor = function SvgReportFilledMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 3h-2.75a1.75 1.75 0 0 0-1.75 1.75v10.5c0 .966.784 1.75 1.75 1.75h7.5a1.75 1.75 0 0 0 1.75-1.75v-5.795h-4.87a1.625 1.625 0 0 1-1.626-1.624l-.003-4.831Zm-1.25 9a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75Zm4.5 0a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75Zm-2.25-1.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5a.75.75 0 0 1 .75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.35 8.205h-4.72a.375.375 0 0 1-.376-.375l-.003-4.699c.212.087.407.216.572.382l4.164 4.164c.154.154.276.333.363.528Z"
  }));
};
SvgReportFilledMinor.displayName = "ReportFilledMinor";

exports.SvgReportFilledMinor = SvgReportFilledMinor;
